<template>
  <div class="prizes-2021-game-place-image">
    <div class="prizes-2021-game-place-image__aspect-box">
      <img
        src="@/assets/img/prizes/2021/game-place-runes.png"
        alt=""
        class="prizes-2021-game-place-image__runes"
      />
      <img
        src="@/assets/img/prizes/2021/game-place-runes-bright.png"
        alt=""
        class="prizes-2021-game-place-image__runes prizes-2021-game-place-image__runes_bright"
      />
      <img
        class="prizes-2021-game-place-image__img"
        src="@/assets/img/prizes/2021/game-place.png"
        alt="Игровое место"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Prizes2021GamePlaceImage"
};
</script>

<style lang="scss">
$runes-width: 797px;
$image-width: 721px;
$image-height: 595px;

.prizes-2021-game-place-image {
  flex-shrink: 0;
  position: relative;
  min-width: 0;
  padding-bottom: 20px;
  flex-grow: 1;
  max-width: 721px;
  pointer-events: none;

  &__aspect-box {
    padding-bottom: $image-height/$image-width * 100%;
    max-width: 100%;
    position: relative;
  }

  &__runes {
    position: absolute;
    top: -5%;
    left: -5%;
    z-index: 1;
    display: block;
    max-width: calc(100% + 5%);
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    max-width: 100%;
  }

  &__runes_bright {
    z-index: 2;
    opacity: 0;
    animation: runes-bright 2s infinite;
  }

  @include breakpoint("md-and-down") {
    max-width: 580px;
  }

  @include breakpoint("sm-and-down") {
    flex: 1 1 auto;
    min-width: 300px;
    padding-bottom: 0;
  }

  @include breakpoint("xs-only") {
    width: 100%;
    max-width: 100%;
    margin-bottom: 25px;
    &__img {
      width: 100%;
    }
    &__runes {
      left: -10px;
    }
  }
}

@keyframes runes-bright {
  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}
</style>
